import { RECEIVE_STATES } from '../constants';

const initialState = [];

const states = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_STATES:
      return [...state, { Code: '', Name: 'Select State' }, ...action.states];
    default:
      return state;
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/reducers/states.js